import { Entity, PrimaryGeneratedColumn, Column, CreateDateColumn, ManyToOne, JoinColumn } from "typeorm";
import { Product } from "../products/product.entity";
import { OcaenFreightRatesEntity } from "./ocean-freights-entity";


@Entity('ocaen_freight_rates_logs')
export class OcaenFreightRateLogsEntity{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;
  
    @Column({
      type:"decimal",precision:10,scale:2,
      nullable: false,
      name: "basic_price"
    })
    basicPrice: number;
  
    @Column({
      type:"decimal",precision:10,scale:2,
      nullable: true,
      name: "other_charge"
    })
    otherCharge: number;
  
    @Column({
      type:"decimal",precision:10,scale:2,
      nullable: false,
      name: "total"
    })
    total: number;
    
   
  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "created_user"
  })
  createdUser: string | null;

  @Column({
    name: "effective_from",
    type: 'datetime'
  })
  effectiveFrom: Date;

  @ManyToOne(type=>OcaenFreightRatesEntity, e=>e.ocaenFreightsInfo,{  nullable:false, })
    @JoinColumn({ name:"ref_id"})
    oceanFreight: OcaenFreightRatesEntity;

    // @ManyToOne(type=>FgpriceList, e=>e.fgPriceInfo,{ nullable:false, })
    // @JoinColumn({ name:"fg_pricelist_id"})
    // FgpriceListId: FgpriceList;

}